import { HttpContext } from '@angular/common/http';
import { SKIP_NOT_FOUND_HANDLING } from '../tokens/skip-not-found-handling.token';

export function skipNotFoundContext(): { context: HttpContext } {
    return {
        context: new HttpContext().set(SKIP_NOT_FOUND_HANDLING, true),
    };
}
